import { Lightning, Colors } from '@lightningjs/sdk';

export default class InputField extends Lightning.Component {
  static _template() {
    return {
      Border: {
        collision: true,
      },
    };
  }

  get _Border() {
    return this.tag('Border');
  }

  _firstEnable() {
    this._Border.patch({
      w: 695,
      h: 67,
    });
  }

  _focus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(694, 67, 10, 4, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._Border.patch({
      texture: null,
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'InputField');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }
}
